import script from "./LangTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./LangTabs.vue?vue&type=script&setup=true&lang=ts"

import "./LangTabs.vue?vue&type=style&index=0&id=291e9134&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-291e9134"]])

export default __exports__